var render = function () {
  var _ref;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: [_vm.$style.container, (_ref = {}, _ref[_vm.$style.horizontal] = _vm.horizontalMenu, _ref)]
  }, _vm._l(_vm.menuList, function (menuItem, idx) {
    var _ref2;

    return _c('div', {
      key: "menu_item_".concat(idx),
      class: _vm.$style.menu
    }, [_c('base-button', {
      class: [_vm.$style.button, (_ref2 = {}, _ref2[_vm.$style.active] = menuItem.active, _ref2[_vm.$style.tooltip] = _vm.shownTooltip, _ref2)],
      attrs: {
        "data-title": _vm.$t(menuItem.title)
      },
      on: {
        "click": function click($event) {
          return _vm.handleClick(menuItem.action);
        }
      }
    }, [_vm.shownText ? _c('span', {
      directives: [{
        name: "m-r",
        rawName: "v-m-r",
        value: 10,
        expression: "10"
      }],
      domProps: {
        "textContent": _vm._s(_vm.$t(menuItem.title))
      }
    }) : _vm._e(), _c('base-icon', {
      staticStyle: {
        "width": "40px",
        "height": "40px"
      },
      attrs: {
        "name": menuItem.icon
      }
    })], 1)], 1);
  }), 0);
}
var staticRenderFns = []

export { render, staticRenderFns }